(function () {
  'use strict';

  /* @ngdoc object
   * @name home.matches
   * @description
   *
   */
  angular
    .module('neo.home.informes', [
      'ui.router'
    ]);
}());